<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="skill.pkid ? '编辑' : '新建'"
      width="600px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="skill"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-form-item v-if="skill.pkid" label="技能编号">
        <el-input v-model="skill.skillNo" disabled/>
      </el-form-item>
      <el-form-item label="技能名称" prop="skillName">
        <el-input v-model="skill.skillName" placeholder="请输入技能名称"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "SkillEdit",
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        skill: {
          pkid: 0,
          skillName: "",
          skillNo: "",
        },
        ruleValidate: {
          skillName: { required: true, message: "请输入技能名称", trigger: "blur" },
        },
      };
    },
    methods: {
      open(id) {
        this.skill.pkid = id;
        this.dialogVisible = true;
        if (id) {
          this.getData();
        }
      },

      // 根据仓库id查询详细信息
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `skills/${this.skill.pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.skill = Object.assign(this.skill, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 提交
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "skills", this.skill)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.skill.pkid) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
